import { DataTable, Thead, Tr, Th, Typography, Tbody, Td } from "@visa/vds";
import React from "react";


export const VsttAboutHorizontalTable = ({ Steps, TableItems }) => (
  <DataTable className="vstt-about-responsive-table">
    <Thead >
      <Tr className="responsive-table-row">
        {Steps.map((step)=>(
            <Th scope="col" style={{backgroundColor: "#1434cb"}}>
                <Typography tag="h3" className="display-flex justify-content-left align-content-left">
                    <div className="vstt-about-bolded-white-text">{step.content}</div>
                </Typography>
            </Th>
        ))}
      </Tr>
    </Thead>
    <Tbody className="vstt-about-tbody-style">
        {TableItems.map((tb)=>(
            <Td className="responsive-table-data">
                <Typography>
                    <div className="vstt-about-tbody-body-style">
                        {tb.content}
                    </div>
                </Typography>
            </Td>
        ))}          
    </Tbody>
  </DataTable>
);

export const VsttAboutVerticalTable = ({ StepsVertical }) => (
  <DataTable className="vstt-about-responsive-vertical-table">
    <Thead >
      <Tr className="responsive-table-row">
        <Th scope="col" style={{backgroundColor: "#1434cb"}}>
          <Typography tag="h3" className="display-flex justify-content-left align-content-left">
              <div className="vstt-about-bolded-white-text">Steps</div>
          </Typography>
        </Th>
        <Th scope="col" style={{backgroundColor: "#1434cb"}}>
          <Typography tag="h3" className="display-flex justify-content-left align-content-left">
              <div className="vstt-about-bolded-white-text">Instructions</div>
          </Typography>
        </Th>
      </Tr>
    </Thead>
    {StepsVertical.map((stepObj) => (
      <Tbody className="vstt-about-tbody-style">
        <Td className="responsive-table-data">
          <Typography>
            <div className="vstt-about-tbody-body-style">
              {stepObj.step}
            </div>
          </Typography>
        </Td>   
        <Td className="responsive-table-data">
          <Typography>
            <div className="vstt-about-tbody-body-style">
              {stepObj.instruction}
            </div>
          </Typography>
        </Td>   
      </Tbody>
    ))}
  </DataTable>
);